import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { translations, pickBilingual } from "../../lib/i18n";
import { TEST_IDS } from "../../constants/testIds";

const initialsOf = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

const Development = ({ developed = [] }) => {
  const { lang } = useLang();
  const t = translations[lang].development;

  return (
    <section
      id="development"
      data-testid={TEST_IDS.development.root}
      className="rp-section bg-[color:var(--rp-bg)]"
    >
      <div className="rp-container">
        <div className="grid grid-cols-12 gap-8 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <div className="rp-eyebrow mb-4">05 · {t.eyebrow}</div>
            <h2 className="rp-heading rp-headline mb-6">{t.title}</h2>
            <p className="font-display text-white text-2xl md:text-3xl max-w-[26ch] leading-tight tracking-tight">
              {t.headline}
            </p>
          </div>
          <div className="col-span-12 lg:col-span-5 flex items-end">
            <p className="rp-lede">{t.body}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {developed.map((p, i) => (
            <motion.div
              key={p.id || p.name}
              data-testid={TEST_IDS.development.card(i)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="rp-card p-6 flex flex-col gap-5"
            >
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--rp-accent)]">
                  0{i + 1}
                </span>
                <div className="w-9 h-9 border border-white/15 flex items-center justify-center font-display font-bold text-xs">
                  {initialsOf(p.name)}
                </div>
              </div>
              <h3 className="font-display font-bold text-white text-xl tracking-tight leading-tight">
                {p.name}
              </h3>
              <p className="text-[13px] text-[color:var(--rp-muted)] leading-relaxed">
                {pickBilingual(p.details, lang)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Development;
